import { ApiError } from '../api/client';

/** i18n keys for guest gate/verify throttle responses (must not look like link expiry). */
export type GuestVerifyThrottleErrorKey = 'errors.rateLimited' | 'errors.verifyLockedOut';

/** Returns a throttle error key when the failure is rate limiting / verify lockout. */
export function guestVerifyThrottleErrorKey(cause: unknown): GuestVerifyThrottleErrorKey | null {
  if (!(cause instanceof ApiError)) {
    return null;
  }
  if (cause.code === 'rate_limited') {
    return 'errors.rateLimited';
  }
  if (cause.code === 'verify_locked_out') {
    return 'errors.verifyLockedOut';
  }
  return null;
}
